"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureValue = void 0;
/**
 * Represents a measure.
 */
class MeasureValue {
    constructor(numerator, denominator) {
        this.numerator = numerator;
        this.denominator = denominator;
    }
    toString() {
        return `${this.numerator}/${this.denominator}`;
    }
    /**
     * Get the measure value as a floating point number.
     */
    get fraction() {
        return this.numerator / this.denominator;
    }
}
exports.MeasureValue = MeasureValue;
